module.exports = __webpack_public_path__ + "img/svg/background-competition-ranked-card.562cecc0c755a38136ad55fcdd340a2e.svg";